import { useState } from "react";
import { Flag } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { API } from "@/lib/api";

const REASONS = ["Listing expired", "Duplicate listing", "Details are wrong", "Not a digital infrastructure role", "Other"];

export const ReportListingForm = ({ jobId }) => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState(REASONS[0]);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    try {
      const response = await fetch(`${API}/jobs/${jobId}/report`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ reason, note }) });
      if (!response.ok) throw new Error("Report failed");
      setDone(true);
      toast.success("Thanks. We'll review this listing.");
    } catch {
      toast.error("Could not send the report. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  if (done) return <p data-testid="job-report-success" role="status" className="text-xs text-[#0FBF77] font-semibold">Report received. Thank you for keeping the board accurate.</p>;
  if (!open) return <button type="button" data-testid="job-report-toggle" onClick={() => setOpen(true)} className="inline-flex items-center gap-1.5 text-xs text-[#5F6168] hover:text-[#0F141B] underline underline-offset-4 transition-colors"><Flag size={12} aria-hidden="true" />Report a problem with this listing</button>;
  return (
    <form data-testid="job-report-form" onSubmit={submit} className="border hairline bg-[#F7F8F9] p-4 space-y-3">
      <label htmlFor={`report-reason-${jobId}`} className="block text-xs text-[#5F6168]">What's wrong?</label>
      <select id={`report-reason-${jobId}`} data-testid="job-report-reason" value={reason} onChange={(event) => setReason(event.target.value)} className="h-10 w-full border border-[#D2D5DA] bg-white px-3 text-sm text-[#0F141B]">
        {REASONS.map((item) => <option key={item} value={item}>{item}</option>)}
      </select>
      <Textarea data-testid="job-report-note" value={note} maxLength={500} onChange={(event) => setNote(event.target.value)} placeholder="Optional details" className="rounded-none border-[#D2D5DA] bg-white text-sm min-h-[72px]" />
      <div className="flex gap-3">
        <Button type="submit" data-testid="job-report-submit" disabled={busy} className="rounded-none h-9 bg-[#0F141B] text-white hover:bg-[#1B222B]">{busy ? "Sending…" : "Send report"}</Button>
        <Button type="button" variant="ghost" data-testid="job-report-cancel" onClick={() => setOpen(false)} className="rounded-none h-9 text-[#5F6168]">Cancel</Button>
      </div>
    </form>
  );
};
